import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { ResponsesPageables } from "../core/models/responesPageables";
import { endpointsURL } from "../constants/endpointsURL";
import { CorrectCoC, FileCorrect } from "./models/correctCoC";
import { ValidateVehiculo } from "../certificates/models";

@Injectable({
  providedIn: "root",
})
export class CocService {
  env = environment.env;
  cocMailBoxURL = endpointsURL.cocMailBoxURL;
  requestURL = endpointsURL.requestURL;

  constructor(private httpClient: HttpClient) {}

  public getCocMailBoxList(filters: string): Observable<ResponsesPageables> {
    return this.httpClient.get<ResponsesPageables>(
      `${this.env}${this.cocMailBoxURL}buzon/list${filters}`
    );
  }

  public getCoc(id: string): Observable<any> {
    let params = new HttpParams().set("idSolicitud", id);
    return this.httpClient.get<any>(
      `${this.env}${this.cocMailBoxURL}buzon/detail`,
      {
        params: params,
      }
    );
  }

  public getCoCQuery(id: string): Observable<any> {
    let params = new HttpParams().set("idSolicitud", id);
    return this.httpClient.get<any>(
      `${this.env}${this.cocMailBoxURL}consulta/detail`,
      {
        params: params,
      }
    );
  }
  public getCoCQueryHistory(id: string): Observable<any> {
    let params = new HttpParams().set("idSolicitud", id);
    return this.httpClient.get<any>(
      `${this.env}${this.cocMailBoxURL}consulta/historyDetail`,
      {
        params: params,
      }
    );
  }

  public sendRequest(request: any, file: any): Observable<any> {
    const fd = new FormData();
    fd.append("_maintenancePeticionesDto", JSON.stringify(request));
    fd.append("_file1", file.file, file.name);
    return this.httpClient.put(
      `${this.env}${this.requestURL}/COC/individual`,
      fd
    );
  }

  public sendRequestMasiva(request: any, file: any): Observable<any> {
    const fd = new FormData();
    fd.append("_maintenancePeticionesDto", JSON.stringify(request));
    fd.append("_file1_excel", file.file, file.name);
    return this.httpClient.put(`${this.env}${this.requestURL}/COC/masiva`, fd);
  }

  public sendRequestMasivaLeasing(
    request: any,
    fileDoc: any,
    fileExcel: any
  ): Observable<any> {
    const fd = new FormData();
    fd.append("_maintenancePeticionesDto", JSON.stringify(request));
    fd.append("_file2", fileDoc.file, fileDoc.name);
    fd.append("_file1_excel", fileExcel.file, fileExcel.name);
    return this.httpClient.put(
      `${this.env}${this.requestURL}/COC/masivaLeasing`,
      fd
    );
  }

  public getQueryListHistoryCoc(
    filters: string
  ): Observable<ResponsesPageables> {
    return this.httpClient.get<ResponsesPageables>(
      `${this.env}${this.cocMailBoxURL}consulta/historyList${filters}`
    );
  }

  public getQueryListCoc(filters: string): Observable<ResponsesPageables> {
    return this.httpClient.get<ResponsesPageables>(
      `${this.env}${this.cocMailBoxURL}consulta/list${filters}`
    );
  }

  public correctCoC(
    files: FileCorrect[],
    correctCocDto: CorrectCoC,
    tipoCertificado: string
  ) {
    const fd = new FormData();

    if (files && files.length > 0) {
      // EL detalle peticion fichero se manda siempre el primero y el segundo si existe el de peticion factura
      let fileDetallePeticionFichero = files.find((file) => file.index == 0);
      if (fileDetallePeticionFichero) {
        fd.append(
          "files",
          fileDetallePeticionFichero.blob,
          fileDetallePeticionFichero.name
        );
      } else {
        fd.append("files", new Blob([], { type: "text/html" }), "empty");
      }

      let fileDetallePeticionFactura = files.find((file) => file.index == 3);
      if (fileDetallePeticionFactura) {
        fd.append(
          "files",
          fileDetallePeticionFactura.blob,
          fileDetallePeticionFactura.name
        );
      } else {
        fd.append("files", new Blob([], { type: "text/html" }), "empty");
      }
    } else if (tipoCertificado === "CML") {
      fd.append("files", new Blob([], { type: "text/html" }), "empty");
      fd.append("files", new Blob([], { type: "text/html" }), "empty");
    } else {
      fd.append("files", new Blob([], { type: "text/html" }), "empty");
    }
    fd.append("updateCertificadoRequest", JSON.stringify(correctCocDto));

    return this.httpClient.put<any>(
      `${this.env}${this.cocMailBoxURL}buzon/update`,
      fd
    );
  }

  public validateVehiculoBastidor(dto: ValidateVehiculo): Observable<any> {
    return this.httpClient.post<any>(
      `${this.env}${this.requestURL}/certificado/validacion/bastidor`,
      dto
    );
  }

  public editarPrecio(peId: string, pePrecio: string)
  {
    const fd = new FormData();
    fd.append("_peId", peId);
    fd.append("_pePrecio", pePrecio);
    return this.httpClient.put<any>(
      `${this.env}${this.cocMailBoxURL}edit/precio`,
      fd
    );
  }
}
